import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'skl-four-oh-four',
  templateUrl: './four-oh-four.component.html',
  styleUrls: ['./four-oh-four.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FourOhFourComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
